export enum Action {
  VIEW = 'view',
  LOGIN = 'login',
  LOGOUT = 'logout',
  CLICK = 'click',
}
